import api from "./core";

const basePath = "api/core/Laboratories";

export default {
  create(data) {
    return api.put(`${basePath}`, data);
  },
  delete(id) {
    return api.delete(`${basePath}/${id}`);
  },
  findNotSent(laboratoryId) {
    return api.get(`${basePath}/FindNotSent/${laboratoryId}`);
  },
  findByLocation(loactionId) {
    return api.get(`${basePath}/FindByLocation/${loactionId}`);
  },
  updateResult(laboratoryOrderId, resultFileId) {
    return api.patch(
      `${basePath}/UpdateResult/${laboratoryOrderId}/${resultFileId}`
    );
  },
  findAll(filter, loactionId) {
    return api.post(`${basePath}/FindAll/${loactionId}`, filter);
  },

  findPanelsByLaboratory(laboratoryId) {
    return api.get(`${basePath}/FindPanels/${laboratoryId}`);
  },
  findAllPanels() {
    return api.get(`${basePath}/FindAllPanels`);
  },

  findTestsByLaboratory(laboratoryId) {
    return api.get(`${basePath}/FindTests/${laboratoryId}`);
  },

  findAllLaboratories() {
    return api.get(`${basePath}/FindAllLaboratories`);
  },
  viewUrl(id) {
    return `${api.getFormsBaseUrl()}${basePath}/Download/${api.getToken()}/${id}`;
  }
};
